import { toast } from 'react-toastify'
import * as actions from "./accountSlice"
import axios from "axios"
import getApiUri from '../../helper/getApiUri'

const apiUrl = getApiUri() + "/accounts"


export const createAccount = async (payload, dispatch) => {
    dispatch(actions.createAccountStart())
    try {
        const { data } = await axios.post(apiUrl, payload)
        dispatch(actions.createAccountSuccess({ id: data.data.account_id, email: data.data.email }))
        toast.success(data.message);
        return true
    } catch (error) {
        dispatch(actions.createAccountFailure())
        console.log(error)
        toast.error(error.response.data.message);
        return false
    }
}


export const createPortal = async (payload) => {
    try {
        const { data } = await axios.post(apiUrl + "/portal", payload)
        return data.data.url
    } catch (error) {
        console.log(error)
        return false
    }
}

export const checkSubscriptionStatus = async (payload, dispatch) => {
    // HR - conitnue to call to backend to check if subscription signup was successful
    const pollInterval = setInterval(async () => {
        try {
            const { data } = await axios.get(apiUrl + `/checkSubStatus/${payload.email}`)
            if (data.data.isActive) {
                clearInterval(pollInterval);
                toast.success(data.message);
                window.dataLayer.push({
                    event: 'subscribe',
                    eventProps: {
                        action: "checkout",
                        label: "subscription_email",
                        value: payload.email
                    }
                });
                window.dataLayer.push({ event: 'conversion_event_subscribe_paid' })
                dispatch(actions.signupAccountSuccess())
                return true
            } else {
                // toast.info(data.message);
                return false
            }
        } catch (error) {
            console.log(error)
            return false
        }
    }, 3000); // Check every 3 seconds
}


export const verifyGoogle = async (payload, dispatch) => {
    try {
        const { data } = await axios.get(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${payload.token}`)

        return data
    } catch (error) {
        if (
            error.response &&
            error.response.status >= 400 &&
            error.response.status < 500
        ) {
            toast.error(error.response.data.message);
        } else {
            console.log(error);
            toast.error("Something went wrong!");
        }
        return false;
    }
};

export const updateAccount = async (payload, dispatch) => {
    dispatch(actions.updateAccountStart())
    try {
        const url = apiUrl + '/' + payload.id
        const { data } = await axios.put(url, payload.data)
        dispatch(actions.updateAccountSuccess(data.data))
        toast.success(data.message)
        return true
    } catch (error) {
        toast.error("Something went wrong!");
        dispatch(actions.updateAccountFailure())
        return false
    }
}

export const getAccountById = async (payload, dispatch) => {
    dispatch(actions.getAccountStart())
    try {
        const url = apiUrl + '/' + payload
        const { data } = await axios.get(url, payload)
        dispatch(actions.getAccountSuccess(data.data))
        toast.success(data.message)
        return true
    } catch (error) {
        console.log(error)
        dispatch(actions.getAccountFailure())
        toast.error(error.response.data.message)
        return false
    }
}

export const handleSubscribe = async (payload, dispatch) => {
        // dispatch(actions.handleSubscribeStart());
    try {
        const url = apiUrl + '/create-checkout-session';
        const { data } = await axios.post(url, payload);

        if (data && data.url) {
            // Open the dynamic Stripe Checkout link in a new tab
            const win = window.open(data.url, '_blank');
            if (win) win.focus();
        }

        // dispatch(actions.handleSubscribeSuccess(data));
        return true;
    } catch (error) {
        toast.error("Something went wrong with checkout!");
        // dispatch(actions.handleSubscribeFailure());
        return false;
    }
}